import { connect, mapProps } from '@formily/vue'

import type { Transfer as ElTransferProps } from '@didi-pebble/pebble-design-vue'
import { Transfer as ElTransfer } from '@didi-pebble/pebble-design-vue'

export type TransferProps = ElTransferProps

export const Transfer = connect(ElTransfer, mapProps({ dataSource: 'data' }))

export default Transfer
